var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex w-full justify-center"},[_c('div',{staticClass:"filter-button fixed z-50 flex h-12 w-48 cursor-pointer flex-row items-center bg-Black88 px-5 py-3 xl:hidden",class:{
      'filter-button-for-app': _vm.isEnotecaAppWebView,
      'with-first-purchase-promo': _vm.isInsideFirstPurchasePromoRange && !_vm.showLogosOnly,
      'with-logos-only': _vm.isInsideFirstPurchasePromoRange && _vm.showLogosOnly,
    },on:{"click":_vm.handleClick}},[_c('p',{staticClass:"mx-auto"},[_vm._v(_vm._s(_vm.title))])])])}
var staticRenderFns = []

export { render, staticRenderFns }